import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sights',
  templateUrl: './sights.component.html',
  styleUrls: ['./sights.component.scss']
})
export class SightsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
